import { useState } from "react";
import "./CustomCallendar.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

interface CustomScrollCalendarProps {
  onDateSelect: (date: Date | null) => void;
}

export default function CustomScrollCalendar({
  onDateSelect,
}: CustomScrollCalendarProps) {
  const today = new Date();
  const [currentDate, setCurrentDate] = useState(today);
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);

  // Utility: generate a full calendar grid with padding for each week
  const getCalendarGrid = (year: number, month: number) => {
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);

    const days: (Date | null)[] = [];

    // Padding before first day
    const startDay = firstDay.getDay();
    for (let i = 0; i < startDay; i++) {
      days.push(null);
    }

    // Actual days in month
    for (let d = 1; d <= lastDay.getDate(); d++) {
      days.push(new Date(year, month, d));
    }

    return days;
  };

  const days = getCalendarGrid(
    currentDate.getFullYear(),
    currentDate.getMonth()
  );

  const changeMonth = (offset: number) => {
    const newDate = new Date(currentDate);
    newDate.setMonth(newDate.getMonth() + offset);
    setCurrentDate(newDate);
    setSelectedDate(null);
  };

  const handleDateClicked = (day: Date) => {
    setSelectedDate(day);
    onDateSelect(day);
  };

  return (
    <div className="calendar-container">
      <div className="calendar-header">
        <button
          className="btn btn-primary btn-sm"
          onClick={() => changeMonth(-1)}
        >
          <FaChevronLeft /> Prev
        </button>
        <h5>
          {currentDate.toLocaleString("en-US", {
            month: "long",
            year: "numeric",
          })}
        </h5>
        <button
          className="btn btn-primary btn-sm"
          onClick={() => changeMonth(1)}
        >
          Next <FaChevronRight />
        </button>
      </div>

      <div className="calendar-grid">
        <div className="weekdays">
          {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day) => (
            <div key={day} className="weekday">
              {day}
            </div>
          ))}
        </div>
        <div className="days">
          {days.map((day, index) => (
            <div
              key={index}
              className={`calendar-day-grid ${
                day
                  ? day.toDateString() === today.toDateString()
                    ? "today"
                    : ""
                  : ""
              } ${
                day &&
                selectedDate &&
                day.toDateString() === selectedDate.toDateString()
                  ? "selected"
                  : ""
              }`}
              onClick={() => day && handleDateClicked(day)}
            >
              {day ? day.getDate() : ""}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
